import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import withIntl from '../../../lib/withIntl';
import './ConsolidateTipsModalContent.scss';
import DynamicArrowLayer from '../ArrowLayer/DynamicArrowLayer';

function ConsolidateTipsModalContent({intl}) {
  const [caddyRefs, setCaddyRefs] = useState([]);

  const doubleCaddyImgSource = './images/double-caddy-consolidate-tips.png';
  const tipCaddyImgSource = './svg/protocol-editor/tip-caddy-rounded.svg';

  const caddy1Ref = useRef(null);
  const caddy2Ref = useRef(null);

  useEffect(() => {
    setCaddyRefs([caddy1Ref, caddy2Ref]);
  }, []);

  return (
    <div id="consolidate-tips-modal-content" className="ct-container">
      <div className="ct-content-row">
        <div className="ct-content-col w-50">
          <div className="fast-instrument-image-container">
            <img src={doubleCaddyImgSource} alt="Consolidate Tips" />
          </div>
        </div>
        <div className="ct-content-col w-50 flex-row">
          <div className="ct-content-col w-50">
            <div className="tip-caddy-image-container" ref={caddy1Ref}>
              <img className="image-tip-caddy" src={tipCaddyImgSource} alt="Tip Caddy" />
              <div className="image-tip-caddy-info">
                {intl.formatMessage({id: 'modal.protocolEditor.consolidateTips.caddyPic1'})}
              </div>
            </div>
          </div>
          <div className="ct-content-col w-50">
            <div className="tip-caddy-image-container" ref={caddy2Ref}>
              <img className="image-tip-caddy" src={tipCaddyImgSource} alt="Tip Caddy" />
              <div className="image-tip-caddy-info">
                {intl.formatMessage({id: 'modal.protocolEditor.consolidateTips.caddyPic2'})}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ct-content-row dialog">
        {intl.formatMessage({id: 'modal.protocolEditor.consolidateTips.dialogText'})}
      </div>
      <DynamicArrowLayer
        sourceRef={caddyRefs[1]}
        destinationRef={caddyRefs[0]}
        options={{strokeWidth: 3, isPositionOnCenter: true}}
      />
    </div>
  );
}

ConsolidateTipsModalContent.propTypes = {
  intl: PropTypes.any.isRequired,
};

ConsolidateTipsModalContent.defaultProps = {};

export default withIntl(ConsolidateTipsModalContent);
